<template>
  <div class="navbar">
    <v-app-bar color="transparent" class="app-bar" dense flat>
      <v-toolbar-title class="ml-5"><router-link :to="{ name: 'home' }" class="black--text link">
        오늘의<span class="font-weight-bold green--text text--lighten-1">세줄</span>
      </router-link></v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="icons mr-5" lgOnly="true">
        <v-btn text color="green lighten-1" v-if="user">
          <v-icon left>mdi-account</v-icon>
          <span class="grey--text text--darken-2">마이 페이지</span>
        </v-btn>
        <v-btn text color="green lighten-1" @click="logout" v-if="user">
          <v-icon left>mdi-account-minus-outline</v-icon>
          <span class="grey--text text--darken-2">로그아웃</span>
        </v-btn>
        <router-link :to="{ name: 'signin' }" class="link" v-if="!user">
          <v-btn text color="green lighten-1">
            <v-icon left>mdi-key</v-icon>
            <span class="grey--text text--darken-2">로그인</span>
          </v-btn>
        </router-link>
        <router-link :to="{ name: 'signup' }" class="link" v-if="!user">
          <v-btn text color="green lighten-1">
            <v-icon left>mdi-account-plus-outline</v-icon>
            <span class="grey--text text--darken-2">회원 가입</span>
          </v-btn>
        </router-link>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'navbar',
  data() {
    return {
      user: null
    }
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.push({ name: 'signin' })
      })
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        this.user = user 
      } else {
        this.user = null
      }
    })
  }
}
</script>

<style>
.link {
  text-decoration: none;
}
</style>